export class AdminFinancialSummary {
  totalPaidOrders: number

  totalOrdersAmount: number

  manualExternalOrdersCount: number

  manualExternalOrderCustomersCount: number

  manualExternalOrdersAmount: number

  manualExternalOrdersNetAmount: number

  totalSplitAmount: number

  totalPlatformFeeAmount: number

  totalRestaurantAmount: number

  totalCourierAmount: number

  averageOrderTicket: number

  platformTakeRatePercentage: number

  approvedSplitsCount: number

  pendingSplitsCount: number

  rejectedSplitsCount: number

  currentMonthPaidOrders: number

  currentMonthManualExternalOrdersCount: number

  currentMonthOrdersAmount: number

  currentMonthManualExternalOrdersAmount: number

  currentMonthManualExternalOrdersNetAmount: number

  currentMonthPlatformFeeAmount: number

  constructor(data: Partial<AdminFinancialSummary> = {}) {
    this.totalPaidOrders = data.totalPaidOrders ?? 0

    this.totalOrdersAmount = data.totalOrdersAmount ?? 0

    this.manualExternalOrdersCount = data.manualExternalOrdersCount ?? 0

    this.manualExternalOrderCustomersCount = data.manualExternalOrderCustomersCount ?? 0

    this.manualExternalOrdersAmount = data.manualExternalOrdersAmount ?? 0

    this.manualExternalOrdersNetAmount = data.manualExternalOrdersNetAmount ?? 0

    this.totalSplitAmount = data.totalSplitAmount ?? 0

    this.totalPlatformFeeAmount = data.totalPlatformFeeAmount ?? 0

    this.totalRestaurantAmount = data.totalRestaurantAmount ?? 0

    this.totalCourierAmount = data.totalCourierAmount ?? 0

    this.averageOrderTicket = data.averageOrderTicket ?? 0

    this.platformTakeRatePercentage = data.platformTakeRatePercentage ?? 0

    this.approvedSplitsCount = data.approvedSplitsCount ?? 0

    this.pendingSplitsCount = data.pendingSplitsCount ?? 0

    this.rejectedSplitsCount = data.rejectedSplitsCount ?? 0

    this.currentMonthPaidOrders = data.currentMonthPaidOrders ?? 0

    this.currentMonthManualExternalOrdersCount = data.currentMonthManualExternalOrdersCount ?? 0

    this.currentMonthOrdersAmount = data.currentMonthOrdersAmount ?? 0

    this.currentMonthManualExternalOrdersAmount = data.currentMonthManualExternalOrdersAmount ?? 0

    this.currentMonthManualExternalOrdersNetAmount = data.currentMonthManualExternalOrdersNetAmount ?? 0

    this.currentMonthPlatformFeeAmount = data.currentMonthPlatformFeeAmount ?? 0
  }
}
